import settings from '@/config/settings';

import type {
  IAirflow,
  IAirflowCreate,
  IAirflowUpdate,
} from '@/api/types/airflow';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

import type {IQueryObject} from '@/assets/core/assets/helpers/serialize';

const url = new URL(settings.SERVICES.BACKEND.URL + '/airflow');

export const airflowAPI = useAPIHook<
  IAirflow,
  IAirflow,
  IAirflowCreate,
  IAirflowUpdate,
  IQueryObject
>(url);
